import { romeApi, utils } from "framework";

const state = {
    amfCode: null,
    flexAeId: null,
    flexAe: null,
    flexAeEmail: null,
    flexAePhone: null,
    flexAePhoneExt: null,
    flexAeCalendlyLink: null,
    cobraAeId: null,
    cobraAe: null,
    cobraAeEmail: null,
    cobraAePhone: null,
    cobraAePhoneExt: null,
    cobraAeCalendlyLink: null,
    camAeId: null,
    camAe: null,
    camAeEmail: null,
    camAeCalendlyLink: null,
    rsmAeId: null,
    rsmAe: null,
    rsmAeEmail: null,
    rsmAePhone: null,
    rsmAePhoneExt: null,
    rsmAeCalendlyLink: null,
    cssId: null,
    css: null,
    cssEmail: null,
    cssPhone: null,
    cssPhoneExt: null,
    cssCalendlyLink: null,
    brokerId: null,
    brokerName: null,
    brokerCompany: null,
    showFlex: false,
    showCobra: false,
    showCss: false,
    showSales: false,
    specialistTypes: {
        Css: {
            displayTitle: 'CSS',
            dto: 'css',
        },
        Flex: {
            displayTitle: 'Flex CRM',
            dto: 'flexAe',
        },
        Cobra: {
            displayTitle: 'Cobra CRM',
            dto: 'cobraAe',
        },
        VP: {
            displayTitle: 'VP, Sales',
            dto: 'rsmAe',
        }
    },
    employerSpecialists: []
};

const getters = {
    employerSpecialistTypes: (state, getters) => {
        return state.specialistTypes},
};
const actions = {
  getEmployerSpecialists({ commit, rootState }) {
    let id = rootState.employer.employerId;
    // console.log("x-employer-specialist getEmployerSpecialists id: ", id);
    if (!id) return;

    romeApi.get(`/employer/${id}/representative`).then(specialists => {
        if (specialists) {
            commit('setEmployerSpecialists', specialists);
            commit('createSpecialists', specialists);
        }
        else commit('clearEmployerSpecialists');
    });
  }
};

const mutations = {
    clearEmployerSpecialists(state) {
        Object.keys(state).forEach(p => state[p] = null);
    },
    setEmployerSpecialists(state, data) {
        utils.copyCommonProperties(data, state);
    },
    createSpecialists(data) {
        state.employerSpecialists = [];

        var flexName = data.flexAeId ? `${state.specialistTypes.Flex.displayTitle}: ${data.flexAe}` : `${state.specialistTypes.Flex.displayTitle}: Unassigned`;
        var flexId = data.flexAeId ? data.flexAeId : null;

        createSpecialist(flexName, flexId, state.specialistTypes.Flex);

        var cobraName = data.cobraAeId ? `${state.specialistTypes.Cobra.displayTitle}: ${data.cobraAe}` : `${state.specialistTypes.Cobra.displayTitle}: Unassigned`;
        var cobraId = data.cobraAeId ? data.cobraAeId : null;

        createSpecialist(cobraName, cobraId, state.specialistTypes.Cobra);

        var vpName = data.rsmAeId ? `${state.specialistTypes.VP.displayTitle}: ${data.rsmAe}` : `${state.specialistTypes.VP.displayTitle}: Unassigned`;
        var vpId = data.rsmAeId ? data.rsmAeId : null;

        createSpecialist(vpName, vpId, state.specialistTypes.VP);

        var cssName = data.cssId ? `${state.specialistTypes.Css.displayTitle}: ${data.css}` : `${state.specialistTypes.Css.displayTitle}: Unassigned`;
        var cssId = data.cssId ? data.cssId : null;

        createSpecialist(cssName, cssId, state.specialistTypes.Css);
    }
};

function createSpecialist(name, id, type) {
    var specialist = {
        name: name,
        id: id,
        type: type,
    }
    state.employerSpecialists.push(specialist);
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/employer/x-employer-specialists.js